import React, { useState } from 'react';
import Stylesheet from './File.module.css';
import { AppContext } from '../../contexts/app';
import { ico_exclamation_triangle } from '../../icon';
import Video from '../Video/Video';

const File = (props) => {
    const [values, setValues] = useState(null);
    let app = null;

    const accept = () => {
        let collection = [];
        // check if current file type is acceptable
        for (const accept of props.accept) {
            switch (accept) {
                case 'application/word':
                    collection.push('application/vnd.openxmlformats-officedocument.wordprocessingml.document');
                    break;
                case 'application/powerpoint':
                    collection.push('application/vnd.openxmlformats-officedocument.presentationml.presentation');
                    break;
                case 'application/msexcel':
                    collection.push('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                    break;
                case 'application/mscsv':
                    collection.push('application/vnd.ms-excel');
                    break;
                default:
                    collection.push(accept);
                    break;
            }
        }
        return collection.join(',');
    }

    /**
     * 
     * @param {FileList} collection 
     */
    const validate = (collection) => {
        if (collection.length > 0) {
            if (!props?.accept) {
                // no file reistrictions set
                setValues(collection);
                if (props?.onChange) 
                    props.onChange(collection);
                return;
            }
             // collection of accepted files from selected
             let files = [];
            // cycle through each selected file
            for (const file of collection) {
                // regex for file type validation
                let accept = null;
                // set simpiifed accept critera for current file
                switch (file.type) {
                    case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                        accept = 'application/word';
                        break;
                    case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                        accept = 'application/powerpoint';
                        break;
                    case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                        accept = 'application/msexcel';
                        break;
                    case 'application/vnd.ms-excel':
                        accept = 'application/mscsv';
                        break;
                    default:
                        accept = file.type;
                        break;
                }
                // check if current file type is acceptable
                for (const type of props.accept) {
                    if (accept === type) {
                        if (props?.onChange) 
                            props.onChange(file);
                        files.push(file);
                        break;
                    }
                }
            }
            if (files.length === 0) {
                app.toggleToast(
                ico_exclamation_triangle, 
                'file types not allowed', true);
            } else if (files.length !== collection.length) {
                app.toggleToast(
                ico_exclamation_triangle, 
                'some files were not accepted', true);
            }
            setValues(files.length === 0 ? null : files)
        }
    }

    const preview = () => {
        if (!props?.preview) return null;
        if (!values) return null;
        // preview is only allowed for signle file selection
        if (!values.length > 1) return null;
        // get uploaded file refference
        let file = values[0];
        // at this time only mp4 videos can be previwed
        if (file.type !== 'video/mp4') return null;
        // show file preview
        return (
            <div className={Stylesheet.Preview}>
                <h4 className={Stylesheet.Title}>preview</h4>
                <Video
                preload='auto' 
                src={URL.createObjectURL(file)} 
                url='static' 
                autoPlay={false} 
                minimal/>
            </div>
        )
    }

    const init = (appContext) => {
        app = appContext;
        return (
            <div className={Stylesheet.Container}>
                {preview()}
                {props.children
                ? <h6 className={Stylesheet.Title}>
                {props.title}</h6>: null}
                <div className={Stylesheet.Fieldset}>
                    {props?.icon
                    ? <div className={Stylesheet.Label}>
                    <h2>{props.icon}</h2></div>: null}
                    <div className={Stylesheet.Input}>
                        <input 
                        onChange={event => validate(event.target.files)}
                        type='file'
                        accept={accept()}
                        disabled={props?.disabled || false}
                        title={props.title} />
                    </div>
                </div>
            </div>
        )
    }

    return (
        <AppContext.Consumer>
            {app => (
                init(app)
            )}
        </AppContext.Consumer>
    )
}

export default File;